import { setFindingDeleteRowData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type SetFindingDeleteRowProps = ApiMethodBase & {
    type: string;
    row: number;
    id: number;
};

export const setFindingDeleteRow = ({
    type,
    row,
    id,
}: SetFindingDeleteRowProps) => {
    setFindingDeleteRowData(type, row, id);
};
